<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li><span class="link-effect">Inducciones Programadas</span></li>
      </ol>
    </div>
  </div>
</div>
<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Inducciones Programadas</h3>
    </div>

    <!-- FILTROS -->
    <div class="block-content">
      <div class="form-horizontal">
        <app-induccion-filtros-busqueda [modelFilter]="modelFilter" [displayFechaAprobacion]="false"
          [displayFechaInduccion]="true"></app-induccion-filtros-busqueda>

        <div class="form-group">
          <label class="col-md-2 control-label">Estado:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Seleccione: </mat-label>
              <mat-select matSelect [(ngModel)]="modelFilter.estados" name="idEstado" multiple>
                <mat-option *ngFor="let item of listaEstadoInducciones; index as i" [value]="item.idParametroDetalle">{{
                  item.nombre }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <!-- RESULTADOS -->
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <div class="col-sm-6 text-left">

            <a class="btn btn-celeste" mat-raised-button (click)="export()"><mat-icon>table_chart</mat-icon>
              Exportar</a>
          </div>
          <div class="col-sm-6 text-right">
            <a class="btn btn-cyan" mat-raised-button (click)="search()"><mat-icon>search</mat-icon> Buscar</a>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table mat-table [dataSource]="modelListaInducciones" class="table table-striped table-vcenter">
          <ng-container matColumnDef="codigo_solicitud">
            <th mat-header-cell *matHeaderCellDef>Código Solicitud</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.codigoSolicitud }}
            </td>
          </ng-container>

          <ng-container matColumnDef="compania">
            <th mat-header-cell *matHeaderCellDef>Compañía</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.compania }}</td>
          </ng-container>

          <ng-container matColumnDef="sede">
            <th mat-header-cell *matHeaderCellDef>Sede</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.sede }}</td>
          </ng-container>

          <ng-container matColumnDef="trabajador">
            <th mat-header-cell *matHeaderCellDef>Trabajador</th>
            <td mat-cell *matCellDef="let element">
              {{ element.persona.nombres }} {{ element.persona.apellidoPaterno }}
              {{ element.persona.apellidoMaterno }}
            </td>
          </ng-container>

          <ng-container matColumnDef="nroDocumentoIdentidad">
            <th mat-header-cell *matHeaderCellDef>Nro Documento Identidad</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.persona.nroDocumentoIdentidad }}
            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="fecha_aprobacion">
            <th mat-header-cell *matHeaderCellDef>Fecha de Aprobación</th>
            <td mat-cell *matCellDef="let element">
              {{ element.fechaAprobacion | date: "dd/MM/yyyy" }}
            </td>
          </ng-container> -->

          <ng-container matColumnDef="fecha_induccion">
            <th mat-header-cell *matHeaderCellDef>Fecha y hora de Inducción</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.fechaHoraInduccion | date: "dd/MM/yyyy HH:mm" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.estado }}</td>
          </ng-container>

          <!-- <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let element">
              <a
                mat-icon-button
                color="primary"
                aria-label="Ver"
                [routerLink]="['/inducciones/', element.idInduccion]"
              >
                <mat-icon>remove_red_eye</mat-icon>
              </a>
            </td>
          </ng-container> -->

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-paginator #paginator [length]="resultsLength" [pageSize]="30" (page)="getPaginatorData($event)"
          [pageSizeOptions]="[30, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>